<template>
    <div class="template-base">
        <Header Title="Data Exports" :iconPath="'/images/icons/database-export.png'" class="div-header" ></Header>
        <div class="menu-bar">
            <Button class="x-smaller-button" :buttonModel="btnExit" :disabled="fetchingData"></Button>
            <Button class="x-smaller-button" :buttonModel="btnExport" @on-clicked="exportData" 
                :disable="fetchingData || selectedReport == null || selectedReport == ReportExportTypes.None || selectedTenants.length == 0" >
            </Button>
            <!-- Header-->
            <div style="display:flex; height: 50px;">
                <div class="data-export-input-container">
                    <span>Report Data</span>
                    <select style="width:300px;" required v-model="selectedReport" :disabled="fetchingData">                            
                            <option v-bind:value="ReportExportTypes.BallsDispensed">Balls Dispensed</option>                        
                        </select>
                </div>

                <div class="data-export-input-container">
                    <span>Start</span>
                    <input style="height:25px" class="data-export-input-item-select" type="date" v-model="dteStart" :disabled="fetchingData"/>
                </div>
                <div class="data-export-input-container">
                    <span>End</span>
                    <input style="height:25px" class="data-export-input-item-select" type="date" v-model="dteEnd" :disabled="fetchingData"/>
                </div>
            </div>
        </div>

        
        <div style="display: flex; flex-direction: row; align-items: center;height: 80%;margin-top: 40px;">
            <!-- Sites -->
            <div style="margin:10px" class="data-export-container">                
                <div class="data-export-site-container">
                    <!-- Title and Buttons -->
                    <div style="width:100%; display: flex; flex-direction: row;justify-content: space-between;">
                        <div style="font-size: 18pt;">Portal ({{ selectedTenants.length }})</div>                                        

                        <div style="width: 70%; display: flex; flex-direction: row;justify-content: flex-end; margin-bottom: 10px;">
                        
                            <!-- <select class="" v-model="currentTimezone" style="width:300px; margin-right: 10px;" @change="updateFilter" v-if="!fetchingData">
                                <option v-for="timezone in timezones" :key="timezone" :value="timezone">{{ timezone }}</option>
                            </select> -->

                            <div class="data-export-button" @click="selectedTenants = tenants.map((t) => t.tenantId)" v-if="!fetchingData">All</div>
                            <div class="data-export-button" @click="selectedTenants = []" v-if="!fetchingData">Clear</div>
                        </div>
                    </div>

                    <div style="width:100%; display: flex; flex-direction: row;justify-content: flex-end; margin-bottom: 10px;" v-if="!fetchingData">
                        <div style="width:100%; display: flex; flex-direction: column;justify-content: flex-end;">
                            <div style="display: flex; flex-direction: column;justify-content: center; margin-right: 10px;">Timezones</div>
                            <select class="" v-model="currentTimezone" style="width:300px; margin-right: 10px;" @change="updateFilter">
                                <option v-for="timezone in timezones" :key="timezone" :value="timezone">{{ timezone }}</option>
                            </select>
                        </div>
                        <div style="width:100%; display: flex; flex-direction: column;justify-content: flex-end;">
                            <div style="display: flex; flex-direction: column;justify-content: center; margin-right: 10px;">Site Name</div>
                            <input type="text" v-model="searchNameText" :onKeyUp="updateFilter" aria-label="Filter hotkeys" />
                        </div>
                    </div>

                    <!-- List -->
                    <div class="data-export-checkbox-list">
                        <div v-for="(tenant, index) in tenants" :key="tenant.tenantId" class="data-export-checkbox-row" @click="handleClick($event, tenant, index)">
                            <div>                            
                                <label :class="{ selected: selectedTenants.includes(tenant.tenantId) }">
                                    <input type="checkbox" :value="tenant.tenantId" v-model="selectedTenants" @click.stop :disabled="fetchingData"/>
                                    {{ tenant.tenantName }} <span style="font-size: 8pt;">({{ tenant.timezone }})</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
            
            <!-- Progress -->
            <div style="margin:10px" class="data-export-container">
                <!-- For future -->
            </div>
        </div>
        
    </div>
</template>

<script>
import Header from "@/views/components/Shared/Header";
import Button from "@/views/components/Shared/Button";
import ButtonModel from "@/common/models/ButtonModel";
import { ref,  } from "vue";
import { getCurrentInstance, onMounted } from "@vue/runtime-core";
import apiTenant from "@/api/apiTenant";
import apiReport from "@/api/apiReport";
import { storage } from "@/common/storage";
import Helper from "@/common/helper";
import { ReportExportTypes } from "@/common/enums";

export default {
    components: { Header, Button },
    setup() {
        const emitter = getCurrentInstance().appContext.app.config.globalProperties.emitter;
        const fetchingData = ref(false);        
        const dteStart = ref(storage.getReportDateStart());
        const dteEnd = ref(storage.getReportDateEnd());
        const timezones = ref([]);
        const currentTimezone = ref(null);
        const searchNameText = ref("");

        const btnExit = ButtonModel.CreateRoute("", "Home");
        btnExit.iconPath = "/images/icons/exit.png";
        btnExit.title = "Back to Main Page";

        const btnExport = ButtonModel.CreateClick("");
        btnExport.iconPath = "/images/icons/export-csv.png";
        btnExport.title = "Export report data...";

        const tenants = ref([]);
        const selectedReport = ref(null);        

        const selectedTenants = ref([]);                       

        onMounted(() => {
            getData();
        });


        let allTenants = []

        const getData = async () => {
            try {
                emitter.emit("server-call-start", "Loading...");
                fetchingData.value = true;
                allTenants = await apiTenant.getTenantTimezoneList();                             
                tenants.value = allTenants
                timezones.value = Array.from(new Set(tenants.value.map((t) => t.timezone))).sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));
                timezones.value = ["All", ...timezones.value]
            } catch (err) {
                console.log("ERROR:", err);
                emitter.emit("show-alert", ["Error loading data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
        };

        const lastIndex = ref(null);
        function handleClick(event, tenant, index) {
            if (fetchingData.value)
                return;
            const id = tenant.tenantId;

            if (event.shiftKey && lastIndex.value !== null) {                
                // --- SHIFT: select a range between last clicked and current ---
                const [start, end] = [lastIndex.value, index].sort((a, b) => a - b);
                const rangeIds = tenants.value.slice(start, end + 1).map((t) => t.tenantId);
                const set = new Set([...selectedTenants.value, ...rangeIds]);
                selectedTenants.value = [...set];
            } else if (event.metaKey || event.ctrlKey) {
                // --- CTRL/CMD: toggle current one ---
                if (selectedTenants.value.includes(id)) {
                    selectedTenants.value = selectedTenants.value.filter((x) => x !== id);
                } else {
                    selectedTenants.value.push(id);
                }
            } else {                                
                if (selectedTenants.value.includes(id)){
                    selectedTenants.value.splice(selectedTenants.value.indexOf(id), 1)
                }
                else {
                    selectedTenants.value.push(id);
                }
            }            
            lastIndex.value = index;
        }        
        
        const exportData = async () => {                        
            try {
                emitter.emit("server-call-start", "Getting data. Please wait...");
                fetchingData.value = true;

                if (selectedReport.value == ReportExportTypes.BallsDispensed) {
                    await apiReport.jobExportBallsDispensed(selectedTenants.value, dteStart.value, dteEnd.value)                    
                }

                emitter.emit("set-jobs-running", true);
                emitter.emit("open-job-view");
                
            } catch (err) {                
                console.log("ERROR:", err);                
                emitter.emit("show-alert", ["Error getting data", err]);
            }
            emitter.emit("server-call-stop");
            fetchingData.value = false;
            
        }        
        
        
        const updateFilter = () => {                           
            
            console.log(currentTimezone.value, searchNameText.value)
            
            tenants.value = allTenants.filter(t => {
                const isSelected = selectedTenants.value.includes(t.tenantId);
                const matchTimezone =
                    currentTimezone.value === "All" ||
                    currentTimezone.value == null ||
                    t.timezone === currentTimezone.value;
                const matchSearch =
                    searchNameText.value === "" ||
                    t.tenantName.toLowerCase().includes(searchNameText.value.toLowerCase());

                return isSelected || (matchTimezone && matchSearch);
            });

        }
        

        return {
            btnExit,
            dteStart,
            dteEnd,
            Helper,
            fetchingData,
            tenants,            
            selectedReport,
            btnExport,            

            ReportExportTypes,
            selectedTenants,
            handleClick,
            exportData,
            timezones,
            currentTimezone,
            searchNameText,
            updateFilter
        };
    }
};
</script>

<style scoped>

.data-export-container {
    display: flex;
    flex-direction: row;
    align-items: flex-start;    
    gap: 20px;
    width: 100%;
    height: 100%;
    padding: 20px;
}

.data-export-site-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    /* background-color: red; */
}

.data-export-button {
    color: var(--button-color);
    padding: 4px;
    margin-right: 10px;
    width: 70px;
    cursor: pointer;
    text-align: center;
    border: 1px solid black;
}

.data-export-checkbox-list {
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 4px;
    background: #fff;
    width: 100%;
    height: 90%;
}

.data-export-checkbox-row {
    cursor: pointer;
    padding: 4px;
    user-select: none;
}
.data-export-checkbox-row:hover {
    background-color: #f3f3f3;
}

.data-export-progress-container {
    width: 100%;
    background-color: #eee;
    /* border-radius: 10px; */
    overflow: hidden;
    height: 30px;
    /* margin-bottom: 10px; */

}

.data-export-progress-bar {
    height: 100%;
    width: 0%;
    background-color: var(--job-runner-color);
    transition: width 0.3s ease;    
}




.data-export-input-container {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    /* margin: 10px 0px; */
    padding: 0px 10px;
}
.data-export-input-item-select {
    width: 161px;
    height: 30px;
}
.data-export-listing {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
}

.data-export-section-group {
    width: 30%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 20px;
}

.data-export-section {
    margin-top: 10px;
}

.data-export-button-link {
    font-size: 11pt;
}

.data-export-section-title {
    margin-top: 20px;
    font-size: 13pt;
    color: black;
}
</style>
